import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.25 3V1.5m0 1.5v1.5m0-1.5H7.875M2.25 7.5v6.75a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V7.5zM2.25 7.5v-3A1.5 1.5 0 0 1 3.75 3h1.5M5.25 1.5v3M15.75 7.5v-3a1.5 1.5 0 0 0-1.5-1.5h-.375"
    }, null, -1)
  ]))]))
}
export default { render: render }